import { Link } from 'react-router-dom';
import { categories } from '@/mocks/manga';

export default function CategoryGrid() {
  return (
    <section className="max-w-7xl mx-auto px-4 md:px-6 py-14" aria-labelledby="category-title">
      <div className="text-center mb-10">
        <h2 id="category-title" className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
          漫画分类
        </h2>
        <p className="mt-3 text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
          八大分类，涵盖所有热门韩漫类型，找到你最爱的那一款
        </p>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
        {categories.map((cat) => (
          <Link
            key={cat.id}
            to={`/category/${cat.slug}`}
            className="group relative bg-background-50 border border-background-200/70 rounded-lg p-5 md:p-6 hover:border-primary-300 transition-all duration-300 overflow-hidden"
          >
            <div className="absolute -right-4 -bottom-4 w-24 h-24 rounded-full bg-primary-500/5 group-hover:bg-primary-500/10 transition-colors duration-300" />
            <div className="relative z-10">
              <div className="w-11 h-11 flex items-center justify-center rounded-lg bg-primary-100 text-primary-500 mb-4 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                <i className={`${cat.icon} text-xl`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-1.5 whitespace-nowrap">
                {cat.name}
              </h3>
              <p className="text-xs text-foreground-600 line-clamp-2">
                {cat.description}
              </p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}